// extracted by mini-css-extract-plugin
export default {"wrapper":"WristToFloor_wrapper__Foamo","img":"WristToFloor_img__ausGa"};